export const insightsActions = {
  CLICK_INSIGHTS_DRILL_DOWN_KUBERNETES: "CLICK_INSIGHTS_DRILL_DOWN_KUBERNETES",
  CLICK_INSIGHTS_DRILL_DOWN_UBERGRAPH: "CLICK_INSIGHTS_DRILL_DOWN_UBERGRAPH",
  CLICK_INSIGHTS_SELECT_RECOMMENDATION: "CLICK_INSIGHTS_SELECT_RECOMMENDATION",
  CLICK_INSIGHTS_UPDATE_RECOMMENDATION: "CLICK_INSIGHTS_UPDATE_RECOMMENDATION",
} as const;
